import { releaseArtistTypes } from '@/constants'

export function formatReleaseArtistsToString(artists: ReleaseArtist[]): string {
  let displayName = ''
  const mainArtists: string[] = []
  const featuredArtists: string[] = []

  artists.forEach(({ typeId, name }) => {
    if (typeId === releaseArtistTypes.performer || typeId === releaseArtistTypes.primary) {
      mainArtists.push(name)
    } else if (typeId === releaseArtistTypes.featured) {
      featuredArtists.push(name)
    }
  })

  if (mainArtists.length) {
    const lastMainArtist = mainArtists.pop()

    displayName = mainArtists.length
      ? `${mainArtists.join(', ')} & ${lastMainArtist}`
      : `${lastMainArtist}`
  }

  if (featuredArtists.length) {
    const lastFeaturedArtist = featuredArtists.pop()

    displayName = featuredArtists.length
      ? `${displayName} (feat. ${featuredArtists.join(', ')} & ${lastFeaturedArtist})`
      : `${displayName} (feat. ${lastFeaturedArtist})`
  }

  return displayName
}
